import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations } from 'use-intl';

import { Button, HeadSideSpeakIcon } from '@/shared-ui';

interface Props {
  isVisible: boolean;
  isFadingOut: boolean;
  isSidebarOpen: boolean;
  onClose: () => void;
  isHandsFree?: boolean;
}

export default function ProjectUsabilitySpeechPrompt({
  isVisible,
  isFadingOut,
  isSidebarOpen,
  onClose,
  isHandsFree = false,
}: Props) {
  const tVoice = useTranslations('Voice');

  if (!isVisible) {
    return null;
  }

  return (
    <div
      data-fading-out={isFadingOut}
      data-is-sidebar-open={isSidebarOpen}
      data-handsfree={isHandsFree}
      data-test='usability-speech-prompt'
      className='absolute z-50 flex items-center gap-3 rounded-2xl px-6 py-4 shadow-lg transition-opacity duration-300 data-[fading-out=true]:opacity-0 data-[handsfree=false]:right-28 data-[handsfree=false]:bottom-10 data-[handsfree=false]:bg-white data-[handsfree=true]:bottom-24 data-[handsfree=true]:left-6 data-[handsfree=true]:bg-gray-800 data-[is-sidebar-open=true]:right-120'
    >
      <div className={isHandsFree ? '[&_svg_path]:fill-white' : ''}>
        <HeadSideSpeakIcon />
      </div>
      <div className='flex max-w-56 flex-col gap-1'>
        <div
          data-is-handsfree={isHandsFree}
          className={`text-sm font-semibold text-blue-950 data-[is-handsfree=true]:text-white`}
        >
          {tVoice('speakOutLoudTitle')}
        </div>
        <div
          data-is-handsfree={isHandsFree}
          className={`text-xs font-normal text-blue-950 data-[is-handsfree=true]:text-white`}
        >
          {tVoice('speakOutLoudSubtitle')}
        </div>
      </div>
      <Button
        variant='ghost'
        size='sm'
        onClick={onClose}
        data-test='usability-speech-prompt-close'
        data-is-handsfree={isHandsFree}
        className={`text-blue-950 data-[is-handsfree=true]:text-white data-[is-handsfree=true]:hover:enabled:bg-gray-700`}
      >
        <FontAwesomeIcon icon={faClose} />
      </Button>
    </div>
  );
}
